import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires Meta Pixel PageView on every client-side route change (SPA).
 * Initial PageView in index.html is removed to avoid double-counting.
 */
function MetaPixelRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
}

export default MetaPixelRouteTracker;
